import { useEffect } from 'react'

import { useSelector } from 'react-redux'
import { createSelector } from 'reselect'

const selectLayoutMode = createSelector(
 (state: any) => state.Layout?.layoutModeType,
 (layoutModeType) => layoutModeType
)

const NonAuthLayout = ({ children }: any) => {
 const layoutModeType = useSelector(selectLayoutMode)

 useEffect(() => {
 if (layoutModeType === 'dark') {
 document.body.setAttribute('data-bs-theme', 'dark')
 document.documentElement.classList.add('dark')
 } else {
 document.body.setAttribute('data-bs-theme', 'light')
 document.documentElement.classList.remove('dark')
 }
 return () => {
 document.body.removeAttribute('data-bs-theme')
 }
 }, [layoutModeType])
 return <div>{children}</div>
}

export default NonAuthLayout
